import { KEY_CODES } from '../util';

class Accordion {
  constructor() {
    this.accordionToggles = document.querySelectorAll('.accordion__toggle');
    this.initialize();
  }

  initialize() {
    const toggles = Array.from(this.accordionToggles);
    toggles.forEach((toggle, index) =>
      toggle.addEventListener('keydown', this.keydown.bind(this, index)),
    );
  }

  keydown(index, e) {
    const toggle = e.target;
    let accordionFocus = index;

    // Checks if accordion at given index is hidden
    const isAccordionHidden = index =>
      this.accordionToggles[index].parentNode.classList.contains('hide');

    switch (e.key) {
      case KEY_CODES.ENTER:
        toggle.checked = !toggle.checked;
        break;

      case KEY_CODES.ARROW_UP:
      case KEY_CODES.ARROW_UP_IE11:
        // Prevent page from shifting
        e.preventDefault();
        // Move focus up to next visible accordion
        do {
          accordionFocus--;
          // If we're at the start, go to the end
          if (accordionFocus < 0) {
            accordionFocus = this.accordionToggles.length - 1;
          }
        } while (isAccordionHidden(accordionFocus));
        break;

      case KEY_CODES.ARROW_DOWN:
      case KEY_CODES.ARROW_DOWN_IE11:
        // Prevent page from shifting
        e.preventDefault();
        // Move focus down to next visible accordion
        do {
          accordionFocus++;
          // If we're at the end, go to the start
          if (accordionFocus >= this.accordionToggles.length) {
            accordionFocus = 0;
          }
        } while (isAccordionHidden(accordionFocus));
        break;

      default:
        break;
    }

    this.accordionToggles[accordionFocus].focus();
  }
}

export default Accordion;
